export default __webpack_public_path__ + "static/media/tonica_02.41262e94.png";